import { render, staticRenderFns } from "./CombatantSlot.vue?vue&type=template&id=7db1138a&scoped=true"
import script from "./CombatantSlot.vue?vue&type=script&lang=js"
export * from "./CombatantSlot.vue?vue&type=script&lang=js"
import style0 from "./CombatantSlot.vue?vue&type=style&index=0&id=7db1138a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db1138a",
  null
  
)

export default component.exports